import { render, staticRenderFns } from "./U_1.vue?vue&type=template&id=2c798f35&"
import script from "./U_1.vue?vue&type=script&lang=js&"
export * from "./U_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "U_1.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
installComponents(component, {
  VDataTable,
  VDivider,
  VImg,
})
